import Component from '../abstracts/Component';

export default class MiniCartComponent extends Component {

  get SELECTORS() {
    return {
      container: '.js-cart-dropdown',
      main: '.js-minicart',
      icon: '.action.cart'
    };
  }

  get CLASSES() {
    return {
      show: 'show',
      removing: 'removing'
    };
  }

  constructor() {
    super();
    this.timeout = null;
    this.timeout2 = null;
    this.container = $(this.SELECTORS.container);
    this.main = $(this.SELECTORS.main);
    this.icon = $(this.SELECTORS.icon);
    this.updated = false;
  }

  openMinicart() {
    clearTimeout(this.timeout);
    clearTimeout(this.timeout2);
    this.container.addClass(this.CLASSES.show);
    this.container.addClass('item-added');
    $('.backdrop-header').addClass('visible');
    const keyboard = document.querySelector('[data-whatinput="keyboard"]');
    const focusableContainer = document.querySelector(this.SELECTORS.container + ' .added-notify');
    const firstFocusable = this.$getFirstFocusable(focusableContainer);
    if (keyboard) {
      setTimeout(() => {
        firstFocusable.focus();
      }, 200);
    } else {
      this.timeout = setTimeout(() => {
        this.container.removeClass(this.CLASSES.show);
        $('.backdrop-header').removeClass('visible');
        this.timeout2 = setTimeout(() => {
          this.container.removeClass('item-added');
        }, 300);
      }, 2000);
    }
  }

  updateQty() {
    let qty = this.main.find('.layer-body').data('items-count');
    if (qty > 0) {
      this.icon.removeClass('icon-cart');
      this.icon.addClass('icon-cart-full');
      let qtySpan = this.container.find('.qty-icon');
      qtySpan.removeClass('d-none');
      qtySpan.text(qty);
    }
  }

  showEmptyMsg($el) {
    let $icon = this.container.find('.qty-icon')
    $icon.fadeOut();
  }

  updateMinicart(addtocart) {

    let ctx = this;
    let $elem = ctx.main;

    if(addtocart){
      return $.ajax({
        url: $elem.data('href'),
        data: {
          'addtocart' : true
        },
        dataType: "html",
        success: function (resp) {
          ctx.log('Minicart updated...');
          $elem.html(resp);
          ctx.updateQty();
        },
        error: function (xhr) {
          console.log(xhr);
        }
      });
    } else {
      return $.ajax({
        url: $elem.data('href'),
        dataType: "html",
        success: function (resp) {
          ctx.log('Minicart updated...');
          $elem.html(resp);
          ctx.updateQty();
        },
        error: function (xhr) {
          console.log(xhr);
        }
      });
      }
  }

  desktopBehaviour() {

    this.$on('mouseenter.minicart', ({
      event
    }) => {
      clearTimeout(this.timeout);
      clearTimeout(this.timeout2);
      //update wishlist only on the first over
      this.firstUpdate(event, 'lg');

    }, `${this.SELECTORS.container}`);

    this.$on('mouseleave.minicart', ({
      event
    }) => {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.close, {
        source: event.currentTarget,
        res: 'lg'
      });
    }, `${this.SELECTORS.container}`);

    $(`${this.SELECTORS.container} ${this.SELECTORS.icon}`).on("keydown", e => {
      const currentDropdown = e.currentTarget.parentElement;
      if (e.which == 13 || e.keyCode == 13) {
        e.preventDefault();
        if (currentDropdown.classList.contains(this.CLASSES.show)) {
          // faccio l'emit del close
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.close, {
            source: currentDropdown,
            res: 'lg'
          });
        } else {
          // faccio l'emit dell'open
          clearTimeout(this.timeout);
          clearTimeout(this.timeout2);
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.closeAll);
          this.firstUpdate(currentDropdown, 'lg');
        }
      }
    });

  }

  firstUpdate(event, br) {
    if (!this.updated) {
      this.updated = true;
      let ct;

      if (event.target) {
        ct = event.currentTarget;
      } else {
        ct = event;
      }

      this.updateMinicart().then(res => {
        if (this.container.is(":hover") || this.icon.is(":focus")) {
          this.$emit(this.$customEvents.DROPDOWN_EVENTS.open, {
            source: ct,
            res: br
          });
        }
      });

    } else {
      this.$emit(this.$customEvents.DROPDOWN_EVENTS.open, {
        source: event.target ? event.currentTarget : event,
        res: br
      });
    }
  }

  bindEvents() {

    let ctx = this;

    // item added to cart
    this.$on(this.$customEvents.PRODUCT_EVENTS.addedtocart, ({
      event,
      payload
    }) => {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.updateMinicart(true).then(res => {
          this.updated = true;
          this.openMinicart();
        });
      }, 800);

    })

    if (this.$matchMedia(null, 'lg')) {
      this.desktopBehaviour();
    }

    window.addEventListener('resize', () => {
      if (this.$matchMedia(null, 'lg')) {
        this.desktopBehaviour();
      } else {
        this.$off('mouseenter.minicart', this.SELECTORS.container);
        this.$off('mouseleave.minicart', `${this.SELECTORS.main}, ${this.SELECTORS.container}`);
      }
    });

  }

  render() {
    this.bindEvents();
  }
}
